import { createSelector } from 'reselect'
import { selectAddToCartCtaEnabled, selectAddToCartCtaText, selectAddToCartTextColor, selectAddToCartBackgroundColor } from 'flux/selectors/property.selectors'

export const selectAddToCartConfigurableParams = createSelector(
  selectAddToCartCtaEnabled,
  selectAddToCartCtaText,
  selectAddToCartTextColor,
  selectAddToCartBackgroundColor,
  (enabled, text, textColor, backgroundColor) => {
    return {
      enabled,
      text,
      textColor,
      backgroundColor,
    }
  },
)
